import React, { useEffect, useState, useCallback, useMemo, useRef } from 'react';
import { useHistory } from 'react-router-dom';

import {
    Button, setResponsiveMode
} from "office-ui-fabric-react";

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import TooltipInput from '../Shared/TooltipInput';
import ModalMessage from '../Shared/ModalMessage';
import { Row, Col } from "react-flexbox-grid";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faCheckSquare, faCoffee } from '@fortawesome/fontawesome-free-solid';
import Select from 'react-select'

import { getUserLogged } from "../../services/loginClient";
import * as apiClient from "../../services/apiClient";
import Loading from "../Loading/Loading";
import {
    removeIndiceFila,
    hayCambiosPendientes, setCambiosPendientes, removeCambiosPendientes,
    removeMockuserSession,
    setPeriodoSession, getPeriodoSession, removePeriodoSession,
    setFlag, getFlag
} from '../Shared/Shared.js';

import '../../custom.css'
import './Mockup.css'

setFlag('isMenuColapsado', false);

const Mockup = (props) => {
    // Limpieza de variables en sessionStorage.
    removeCambiosPendientes();
    removeIndiceFila();
    removeMockuserSession();
    removePeriodoSession();
    // Recuperar parámetros.
    const searchParams = new URLSearchParams('?' + atob(props.location.search.substring(1)));
    setPeriodoSession({ periodo_inicio: searchParams.get('periodo_inicio'), periodo_fin: searchParams.get('periodo_fin') });

    const constantes = {
        operacion: {
            crear: 'I',
            actualizar: 'U',
            eliminar: 'D'
        },
        estado: {
            abierto: 'Abierto',
            cerrado: 'Cerrado'
        }
    }

    const showConsoleLogDebug = false;
    const history = useHistory();
    const gridRef = useRef();
    const [userLogged, setUserLogged] = useState(getUserLogged());
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState('');
    const [translations, setTranslations] = useState([]);

    const [persona, setPersona] = useState(null);
    const [team, setTeam] = useState([]);

    const [period, setPeriod] = useState({});
    const [periods, setPeriods] = useState([]);
    const [position, setPosition] = useState(0);
    const [disableNextPeriod, setDisableNextPeriod] = useState(false);
    const [disablePreviousPeriod, setDisablePreviousPeriod] = useState(false);

    const [domLayoutTeam, setDomLayoutTeam] = useState('autoHeight');
    const [domLayout, setDomLayout] = useState('autoHeight');
    const [gridApiProfessionalHours, setGridApiProfessionalHours] = useState(null);

    const [dynamicColumns, setDynamicColumnsGridColumns] = useState([]);
    const [parents, setParents] = useState([]);

    const [messageTitle, setMessageTitle] = useState("");
    const [messageContent, setMessageContent] = useState("");
    const [messageStatus, setMessageStatus] = useState(false);
    const [messageHeaderBackground, setMessageHeaderBackground] = useState('');

    //const maxRows = 5;
    //const rowHeight = 42;
    //let actualRows = reports.length;
    //const gridHeight = maxRows * rowHeight;

    const language = navigator.language.startsWith('es') ? 'es' : 'en';

    useEffect(() => {
        const GetTranslations = async () => {
            if (showConsoleLogDebug)
                console.log("Mockup.useEffect().GetTranslations()");

            const labels = await apiClient.GetLabelsByFolderAndControllerAndLabelName(language, "TimesheetTasking", "Mockup", "mockup");
            const data = await apiClient.GetTranslationsByLabels(language, labels);

            setMessage((await data).filter(item => 'mockup.Loading' == item.label)[0].body);
            setLoading(true);

            setTranslations(data);
        };

        const GetScreenData = async () => {
            if (showConsoleLogDebug)
                console.log("Mockup.useEffect().GetScreenData()");

            removeCambiosPendientes();
            setCambiosPendientes(false);

            var req = getReq();
            var persona = await apiClient.GetPersonaData(language, req);
            var periodos = await apiClient.GetPeriodsBySociety(language, persona.sociedad);
            var mockuser_periodo = getPeriodoSession();
            var currentDate = new Date();
            var disablePreviousPeriod = false;
            var disableNextPeriod = true;

            if (mockuser_periodo.periodo_inicio != null || mockuser_periodo.periodo_inicio != undefined) {
                console.log("En el if");
                // Si están parametrizadas las fechas del periodo, entonces utilizo la fecha de inicio
                // para recuperar el periodo especificado.
                currentDate = new Date(mockuser_periodo.periodo_inicio);
            }

            var position = periodos.findIndex(per => {
                var fechaInicio = per.fechaInicio;
                var fechaFin = per.fechaFin;

                return currentDate >= new Date(fechaInicio) && currentDate <= new Date(fechaFin);
            });

            // En caso de estar fuera de todos los rangos de periodos,
            // se escoge el periodo más reciente si lo hubiera.
            if (-1 == position && periodos.length > 0) {
                position = periodos.length - 1;
            }

            if (periodos.length == 0) {
                disablePreviousPeriod = true;
            }

            if (position < periodos.length - 1) {
                disableNextPeriod = false;
            }

            //var team = await apiClient.MockupGetTeam(language, req, periodos[position].fechaInicio, periodos[position].fechaFin);
            var team = await apiClient.GetTeam(language, req, periodos[position].fechaInicio, periodos[position].fechaFin);

            var parents = await apiClient.GetParentsProjectsDataBySociedad(language, persona.sociedad);
            var parents_projects_vm = Array.from(
                new Set(parents.map((x) => x.id))
            ).map((id) => {
                return {
                    value: parents.find((x) => x.id === id).idPep,
                    label: parents.find((x) => x.id === id).codigo,
                    name: parents.find((x) => x.id === id).nombre,
                };
            });

            setPersona(persona);
            setTeam(team);
            //setProfSelected({ id: '', nPersonal: '', nombre: '', apellido1: '', apellido2: '', sociedad: '', nombreSociedad: '', horasReportadasPeriodo: 0 });
            setDisablePreviousPeriod(disablePreviousPeriod);
            setDisableNextPeriod(disableNextPeriod);
            setPeriods(periodos);
            setPeriod(periodos[position]);
            setPosition(position);
            setParents(parents_projects_vm);

            setLoading(false);
        };

        const OcultarMenu = () => {
            // Establezco un timeout de 500ms porque de lo contrario no puedo determinar
            // si el menú lateral está o no colapsado.
            setTimeout(() => {
                var isFlagColapsado = getFlag('isMenuColapsado');

                if (!isFlagColapsado) {
                    setFlag('isMenuColapsado', true);

                    if (document.getElementById('sidebar-css').offsetWidth > 100) {
                        document.getElementById('menu_open').click();
                    }
                }
            }, 500);
        }

        GetTranslations();
        setLoading(true);
        GetScreenData();
        OcultarMenu();
    }, []);

    /********************************************************************************* Configuración tabla */
    const getGridColumnsTeam = () => {
        if (showConsoleLogDebug)
            console.log("Mockup.getGridColumnsTeam()");

        let grid_columns = [
            {
                field: "nPersonal",
                headerName: translations.length > 0 ? translations.filter(translations => translations.label == "mockup.Number")[0].body : "",
                type: 'rightAligned',
                filter: "agTextColumnFilter",
                width: 110,
                //pinned: 'left',
                editable: false,
                resizable: true
            },
            {
                field: "nombreCompleto",
                headerName: translations.length > 0 ? translations.filter(translations => translations.label == "mockup.FullName")[0].body : "",
                filter: "agTextColumnFilter",
                width: 400,
                //pinned: 'left',
                editable: false,
                resizable: true,
                //cellRenderer: (field) => {
                //    return `${field.data.nombre} ${field.data.apellido1} ${field.data.apellido2}`;
                //}
            },
            {
                field: "nombreSociedad",
                headerName: translations.length > 0 ? translations.filter(translations => translations.label == "mockup.Company")[0].body : "",
                filter: "agTextColumnFilter",
                width: 400,
                //pinned: 'left',
                editable: false,
                resizable: true
            },
            {
                field: "nombreGrupo",
                headerName: translations.length > 0 ? translations.filter(translations => translations.label == "mockup.Group")[0].body : "",
                filter: "agTextColumnFilter",
                width: 400,
                //pinned: 'left',
                editable: false,
                resizable: true
            },
            {
                field: "horasReportadasPeriodo",
                headerName: translations.length > 0 ? translations.filter(translations => translations.label == "mockup.ReportedHours")[0].body : "",
                type: 'rightAligned',
                filter: "agTextColumnFilter",
                width: 100,
                //pinned: 'left',
                editable: false,
                resizable: true,
                cellRenderer: (field) => {
                    return (
                        <span id={`totalHoras_${field.data.id}`}>{field.data.horasReportadasPeriodo}</span>
                    )
                }
            }
        ];

        return grid_columns;
    }

    const onGridReady = useCallback((params) => {
        if (showConsoleLogDebug)
            console.log("Mockup.onGridReady()");

        params.api.sizeColumnsToFit();

        window.addEventListener('resize', function () {
            setTimeout(function () {
                params.api.sizeColumnsToFit();
            });
        });

        gridRef.current.api.sizeColumnsToFit();
    }, []);
    /************************************************************************** Fin configuración tabla */

    /************************************************************************** Eventos botones */
    const goToPreviousWeek = async () => {
        if (showConsoleLogDebug)
            console.log("Mockup.goToPreviousWeek()");

        setMessage(getTranslation("mockup.Loading"));
        setLoading(true);

        const language = navigator.language.startsWith('es') ? 'es' : 'en';
        setDynamicColumnsGridColumns([]);

        var pos = position;
        pos = pos - 1;
        var periodo = periods[pos];
        var disablePreviousPeriod = false;
        var disableNextPeriod = false;

        if (pos == 0)
            disablePreviousPeriod = true;

        if (pos == periods.length || periods.length <= 1)
            disableNextPeriod = true;

        var req = getReq();
        var team = await apiClient.GetTeam(language, req, periodo.fechaInicio, periodo.fechaFin);

        setTeam(team);
        setPosition(pos);

        setDisablePreviousPeriod(disablePreviousPeriod);
        setDisableNextPeriod(disableNextPeriod);

        setPeriod(periodo);
        setDynamicColumnsGridColumns(dynamicColumns);

        setLoading(false);

    };

    const goToNextWeek = async () => {
        if (showConsoleLogDebug)
            console.log("Mockup.goToNextWeek()");

        setMessage(getTranslation("mockup.Loading"));
        setLoading(true);

        const language = navigator.language.startsWith('es') ? 'es' : 'en';
        setDynamicColumnsGridColumns([]);

        var pos = position;
        pos = pos + 1;
        var periodo = periods[pos];
        var disablePreviousPeriod = false;
        var disableNextPeriod = false;

        if (pos == 0)
            disablePreviousPeriod = true;

        if (pos == periods.length - 1 || periods.length <= 1)
            disableNextPeriod = true;

        var req = getReq();
        var team = await apiClient.GetTeam(language, req, periodo.fechaInicio, periodo.fechaFin);

        setTeam(team);
        setPosition(pos);

        setDisablePreviousPeriod(disablePreviousPeriod);
        setDisableNextPeriod(disableNextPeriod);

        setPeriod(periodo);
        setDynamicColumnsGridColumns(dynamicColumns);

        setLoading(false);
    };
    /************************************************************************** Fin eventos botones */

    /************************************************************************** Eventos producidos en la tabla */
    const onSelectionChanged = async () => {
        if (showConsoleLogDebug)
            console.log("Mockup.onSelectionChanged()");

        setLoading(true);
        const selectedRows = gridRef.current.api.getSelectedRows();
        let query = btoa(`mockuser=${selectedRows[0].nPersonal}&periodo_inicio=${formatDateDataBase(period.fechaInicio)}&periodo_fin=${formatDateDataBase(period.fechaFin)}`);
        window.location.replace(`/timesheettasking/reporthours?${query}`);
    };
    /************************************************************************** Fin eventos producidos en la tabla */

    /************************************************************************** Resto de funciones */
    const getTranslation = (label) => {
        if (showConsoleLogDebug)
            console.log("Mockup.getTranslation()");

        const translation = translations.find((t) => t.label === label);
        return translation ? translation.body : '';
    };

    const getReq = () => {
        return {
            email: userLogged.mail,
            token: userLogged.token
        };
    }
     
    const isPeriodClosed = (periodo) => {
        return undefined != periodo.estado && constantes.estado.cerrado.toLowerCase() == periodo.estado.toLowerCase();
    }
    /************************************************************************** Fin resto de funciones */

    /************************************************************************** Utils */
    function formatDateNumber(num) {
        return num.toString().padStart(2, '0');
    }

    const formatDateString = (date) => {
        var formatDate = [formatDateNumber(date.getDate()), formatDateNumber(date.getMonth() + 1), date.getFullYear()].join('/');
        return formatDate;
    };

    const formatDateDataBase = (date) => {
        var dateToFormat = new Date(date);
        var formatDate = [dateToFormat.getFullYear(), formatDateNumber(dateToFormat.getMonth() + 1), formatDateNumber(dateToFormat.getDate())].join('-');
        return formatDate;
    };
    /************************************************************************** Fin Utils */

    return (
        <div>
            {
                loading &&
                <Loading show={loading} message={message} />
            }

            <ModalMessage
                title={messageTitle}
                message={messageContent}
                show={messageStatus}
                setMessageStatus={setMessageStatus}
                headerBackground={messageHeaderBackground}
                btnCloseText={getTranslation("mockup.Close")}
            />

            <div style={{ height: '600px', overflowY: 'auto' }}>
                <section>
                    <h5>{getTranslation('mockup.Title')}</h5>
                </section>

                <section>
                    <div className="table-container">
                        <Row between="xs" className="row">
                            <Col xs={5}>
                                <div id="goToPreviousWeek">
                                    <h4>
                                        <b>{getTranslation('mockup.Period')} </b>
                                        <button className="icon-week-button" disabled={disablePreviousPeriod} onClick={goToPreviousWeek}>
                                            <i className="fa fa-angle-left" aria-hidden="true"></i>
                                        </button>
                                    </h4>
                                </div>
                                <div id="week">
                                    <label>
                                        <h4>{formatDateString(new Date(period.fechaInicio))} - {formatDateString(new Date(period.fechaFin))}</h4>
                                    </label>
                                </div>
                                <div id="goToNextWeek">
                                    <h4>
                                        <button className="icon-week-button" disabled={disableNextPeriod} onClick={goToNextWeek}>
                                            <i className="fa fa-angle-right" aria-hidden="true"></i>
                                        </button>
                                    </h4>
                                </div>
                            </Col>
                            <Col xs={3}>
                                <h4>{getTranslation('mockup.CloseDate')}: {formatDateString(new Date(period.fechaCierre))}</h4>
                            </Col>
                            <Col xs={1} />
                            <Col xs={3}>
                                <h4 id="statusLabelAlign">{getTranslation('mockup.Status')}: {period.estado}</h4>
                            </Col>
                        </Row>
                    </div>
                </section>

                <section className="mb-2">
                    <div className="table-container">
                        <Row between="xs" className="row">
                            <Col xs={12}>
                                <div className="team-grid ag-theme-alpine">
                                    <AgGridReact
                                        ref={gridRef}
                                        domLayout={domLayoutTeam}
                                        pagination={false}
                                        sizeColumnsToFit={true}
                                        rowData={team}
                                        columnDefs={getGridColumnsTeam()}
                                        rowSelection={'single'}
                                        //pinnedBottomRowData={createData(1, 'Bottom')}
                                        //suppressRowClickSelection={true}
                                        stopEditingWhenCellsLoseFocus={true}
                                        getRowStyle={(params) => {
                                            if (params.node.rowIndex % 2 === 0) {
                                                return { background: '#ececec' };
                                            }
                                        }}
                                        defaultColDef={{
                                            width: 170,
                                            sortable: true
                                        }}
                                        onGridReady={onGridReady}                                        
                                        onSelectionChanged={onSelectionChanged}
                                    />
                                </div>
                            </Col>
                        </Row>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default Mockup;